import { BaseError } from '@kiplin/web-common/error';

export class MissingHostConfigurationError extends BaseError {
  constructor(hostName: string) {
    super('f5f0699c-646a-4c1f-8a4c-9b6d2d4d1b03', `Missing "${hostName}" host configuration`);
  }
}
